import React, { useCallback, useEffect, useRef } from 'react';

const Jotform = ({ scriptSrc, onSubmit }) => {
  const jotformRef = useRef(null);

  const loadJotform = useCallback(
    node => {
      if (node && node.children.length === 0) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = scriptSrc;
        script.async = true;
        node.appendChild(script);
        jotformRef.current = node;
      }
    },
    [scriptSrc]
  );

  useEffect(() => {
    const handleMessage = event => {
      const { data, origin } = event || {};
      if (data?.action === 'submission-completed' && data.formID && origin === 'https://upgrade.jotform.com') {
        onSubmit?.(event.data);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [onSubmit]);

  return <div ref={loadJotform} />;
};

export default Jotform;
